
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Tax = () => {
  return (
    <SettingsMetaData propertyName={"Tax_invoicesIncoming"} viewPropertyName={"Tax"} />
  );
};
export default Tax;
